import React, { useState, useEffect, useContext, useRef } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { MapContainer, Marker, TileLayer, Polyline, Tooltip } from 'react-leaflet'
import { useHistory } from 'react-router-dom'
import Axios from 'axios'
import endpoints from '../js/endpoints'

import { originPin, dest1Pin } from '../js/markers'
import TripContext from '../contexts/TripContext'
import context from 'react-bootstrap/esm/AccordionContext'
import { Route, Switch, useLocation } from 'react-router-dom'
import pagePath from '../pagePath'


export default function DriverLocation(props) {
  const [map, setMap] = useState()
  const [animatee, setAnimatee] = useState(true)

  const history = useHistory()
  const search =props.match.params.id;
  const [driverLocation, setDriverLocation] = useState({
    lat: 0,
    lng: 0,
    date: '',
    time: '',
    bearing: 0
  })

  let tripContext = useContext(TripContext)

  useEffect(() => {
    setInterval(
      () => {
        getDriverLocation()
      }
      , 3000)

  }, [map])





  const [mapOption, setMapOption] = useState({
    //TODO
    center: [32.81710238289377, 53.90728552250239],
    zoom: 6,
    latLngs: [],
    bounds: [],
    acceptOrigin: false,
    acceptDest1: false,
    acceptDest2: false,
    color: { color: 'red' },
  })

  let getBounds = () => {
    var corner1 = L.latLng(mapOption.latLngs[0]),
      corner2 = L.latLng(mapOption.latLngs[mapOption.latLngs.length - 1]),
      bounds = L.latLngBounds(corner1, corner2)
    return bounds
  }

  let goToLocation = (lat, lng) => {


    console.log('animate', animatee)
    if (map)
      if (animatee) {
        setAnimatee(false)
        map.setView([lat, lng], 14, { animate: true });

      }


  }
  let goTripInfo = () => {
    console.log(tripContext)
    history.replace(pagePath.tripInfo + search)
  }



  let getDriverLocation = () => {
    Axios({
      url: endpoints.GetDriverPosition,
      method: 'get',
      params: { refNum: search },
    })
      .then((res) => {
        setDriverLocation((prevTrip) => ({
          ...prevTrip,
          lat: res.data.result.lat,
          lng: res.data.result.lng,
          date: res.data.result.date,
          time: res.data.result.time,
          bearing: res.data.result.bearing
        }))
        if (res.data.result.lat != 0)
          goToLocation(res.data.result.lat, res.data.result.lng)

      })
      .catch(function (error) {
        console.log(error)
      })

  }

  return (
    <>

      <div className='d-flex' >

        <MapContainer
          whenCreated={setMap}
          className="position-fixed"
          center={mapOption.center}
          zoom={mapOption.zoom}
          bounds={getBounds()}
          boundsOptions={{ padding: [50, 50] }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="Map data © efspco"
          />
          <Polyline pathOptions={mapOption.color} positions={mapOption.latLngs} />

          {
            (driverLocation?.lat !== 0) ?
              <Marker position={[driverLocation.lat, driverLocation.lng]} icon={originPin} >
                <Tooltip>
                  <span>{`آخرین تاریخ: ${driverLocation.date}   ${driverLocation.time}`}</span>
                </Tooltip>
              </Marker>
              : <></>
          }

        </MapContainer>
        <button
          type="button"
          className="btn btn-danger text position-relative  m-2"
          onClick={goTripInfo}>
          بازگشت به صفحه قبل
        </button>


      </div>

    </>

  )
}
